export interface ImageRecord {
    image_id: string;
    /**
     * 大图
     */
    storage_path: string;
    /**
     * 缩略图
     */
    fulltext_image240_url: string;
}

export interface IOrgInfo {
    display_name?: string;
    logo?: string;
    id?: string;
    normalized_display_name?: string;
    normalized_id?: string;
    normalized_logo?: string
}

export enum SOLUTION_TYPE {
    PATENT = 'PATENT',
    PAPER = 'PAPER',
    WEBSITE = 'WEBSITE',
    NEWS = 'NEWS',
    REPORT = 'REPORT'
}

export interface AUTHOR {
    id: string;
    name: string;
}

export enum EContentType {
    ABST = 'ABST',
    TECHNICAL_TITLE = 'TECHNICAL_TITLE'
}

export interface ISolution extends Record<string, any> {
    SOLUTION_ID: string;
    CONTENT: string;
    CONTENT_TYPE?: EContentType;
    TITLE?: string;
    ORG_INFO?: IOrgInfo[];
    APD?: string;
    SIMPLE_LEGAL_STATUS?: string | number;
    PDF_IMAGE?: ImageRecord[];
    PDF_IMAGE_COUNT?: number;
    SOLUTION_TYPE: SOLUTION_TYPE;
    PATENT_UPDATE_TS?: number | string | Date;
    PN?: string;
    DOI?: string;
    AUTHORS?: AUTHOR[]
    WEBSITE?: {
        name: string
        url: string
    }[]
    PUBLISH_TIME?: string
    JOURNAL?: string,
    PBD?: string
    LINK?: string
    // 市场报告
    PUBLISHER?: string;
    PUBLISHED_TIME: number;
    CATEGORY?: {
        name: string;
        id: string;
    }[];
    AVG_CAGR: number;
}

export interface ISolutionListResponse {
    page: number;
    limit: number;
    has_previous: boolean;
    has_next: boolean;
    total: number;
    records: ISolution[];
}

export enum SOLUTION_TYPE_LABEL {
    PATENT = 'bg-green-40 text-green-500',
    PAPER = 'bg-blue-40 text-eureka-500',
    WEBSITE = 'bg-[#F3EEF8] text-purple-500',
    NEWS = 'bg-spring-40 text-spring-600',
    REPORT = 'bg-yellow-40 text-yellow-500'
}
